import { AppState } from '@/store';
import { Breadcrumbs } from '@components/tailwind';
import Picture from '@components/tailwind/Picture';
import { useSelector } from 'react-redux';

const Header = () => {
  const {
    partnerData: {
      partner: { headerUrl, bannerUrl, tagline, title: partnerTitle },
    },
    activeGroup,
  } = useSelector((state: AppState) => state.partner);

  return (
    <>
      {bannerUrl && (
        <div className='tw-h-[250px] tw-w-full'>
          <img
            src={bannerUrl}
            alt={`${tagline} Banner`}
            className='tw-h-full tw-w-full tw-object-cover tw-object-center'
          />
        </div>
      )}

      <Breadcrumbs
        crumbs={[
          {
            text: 'Home',
            url: '/',
            isInternalLink: false,
          },
          {
            text: 'MyRTIC',
            url: '/myrtic',
            isInternalLink: false,
          },
          {
            text: partnerTitle,
            url: '#',
            isInternalLink: false,
          },
        ]}
      />

      {headerUrl && (
        <img
          src={headerUrl}
          alt={`${tagline} Header`}
          className='tw-mx-auto tw-mt-[30px] tw-mb-4 tw-block tw-max-h-[84px] tw-w-auto md:tw-max-h-[111px]'
        />
      )}

      {tagline && <p className='tw-text-center tw-text-xl tw-font-bold tw-text-body'>{tagline}</p>}

      {activeGroup?.headerImage && (
        <Picture picture={activeGroup.headerImage} className='tw-mb-10 tw-block' />
      )}
    </>
  );
};

export default Header;
